import {CommonService} from './common.service';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Socket} from 'ngx-socket-io';

@Injectable({
  providedIn: 'root'
})

export class SalePointsService {
  public insertedSalePoints: Observable<any>;
  public deactivatedSalePoints: Observable<any>;
  private serviceModel: string;

  constructor(private commonService: CommonService,
              private httpClient: HttpClient,
              private socket: Socket) {
    this.insertedSalePoints = this.socket.fromEvent<any>('insertSalePoint');

    this.serviceModel = 'sale_point';
  }

  public getSalePoint(id: number): Promise<any> {
    return new Promise((resolve) => {
      this.httpClient.get(`${this.serviceModel}?first=true&filter=id=${id}`).subscribe((result) => {
        resolve(result);
      });
    });
  }

  public getSingleSalePoint(id: number): Promise<any> {
    return new Promise((resolve) => {
      this.httpClient.get(`${this.serviceModel}/single?first=true&filter=id=${id}`).subscribe((result) => {
        resolve(result);
      });
    });
  }

  public getSingleSalePointPreviousVersion(eventLogID: number): Promise<any> {
    return new Promise((resolve) => {
      this.httpClient.get(`${this.serviceModel}/version?first=true&filter=id=${eventLogID}`).subscribe((result) => {
        resolve(result);
      });
    });
  }

  public getUserSalePoints(filter: string): Promise<any> {
    return new Promise((resolve) => {
      this.httpClient.get(`${this.serviceModel}?filter=${filter}`).subscribe((result) => {
          resolve(result);
        });
    });
  }

  public getUserSalePointsCount(filter: string): Promise<any> {
    return new Promise((resolve) => {
      this.httpClient.get(`${this.serviceModel}?filter=${filter}&select=COUNT(*) AS count`)
        .subscribe((result) => {
          resolve(result);
        });
    });
  }

  public updateSalePointKey(model: UpdateEntities) {
    return new Promise((resolve) => {
      this.httpClient.put(`sale_point/join_sap`, model).subscribe(result => {
        resolve(result);
      });
    });
  }

  public initializeSalePoint(salePoint: any, previousSalePoint?: any): any[] {
    return [
      {
        title: 'Στοιχεία Σημείου Πώλησης',
        id: salePoint.id,
        values: [
          {
            color: this.setFieldColor(salePoint, 'customer_name', previousSalePoint),
            name: 'Επωνυμία',
            value: this.commonService.setValue(salePoint.customer_name)
          },
          {
            name: 'Α.Φ.Μ.',
            value: this.commonService.setValue(salePoint.vat_number)
          },
          {
            color: this.setFieldColor(salePoint, 'account_group_name', previousSalePoint),
            name: 'Βασική Ομάδα Πελατών',
            value: this.commonService.setValue(salePoint.account_group_name)
          },
          {
            color: this.setFieldColor(salePoint, 'regional_name', previousSalePoint),
            name: 'Περιφερειακός Διευθυντής',
            value: this.commonService.setValue(salePoint.regional_name)
          },
          {
            color: this.setFieldColor(salePoint, 'inspector_name', previousSalePoint),
            name: 'Επιθεωρητής',
            value: this.commonService.setValue(salePoint.inspector_name)
          },
          {
            color: this.setFieldColor(salePoint, 'sales_group_name', previousSalePoint),
            name: 'Δρομολόγιο',
            value: this.commonService.setValue(salePoint.sales_group_name)
          },
          {
            color: this.setFieldColor(salePoint, 'customer_group1_name', previousSalePoint),
            name: 'Ομάδα Πελατών 1',
            value: this.commonService.setValue(salePoint.customer_group1_name)
          },
          {
            color: this.setFieldColor(salePoint, 'customer_group2_name', previousSalePoint),
            name: 'Ομάδα Πελατών 2',
            value: this.commonService.setValue(salePoint.customer_group2_name)
          },
          {
            color: this.setFieldColor(salePoint, 'customer_code', previousSalePoint),
            name: 'Κωδικός Πελάτη',
            value: this.commonService.setValue(salePoint.customer_code)
          },
          {
            color: this.setFieldColor(salePoint, 'plirotis_name', previousSalePoint),
            name: 'Επωνυμία Πληρωτή',
            value: this.commonService.setValue(salePoint.plirotis_name)
          },
          {
            color: this.setFieldColor(salePoint, 'language_name', previousSalePoint),
            name: 'Γλώσσα',
            value: this.commonService.setValue(salePoint.language_name)
          },
          {
            color: this.setFieldColor(salePoint, 'type_name', previousSalePoint),
            name: 'Είδος Σημείου Πώλησης',
            value: this.commonService.setValue(salePoint.type_name)
          },
          {
            color: this.setFieldColor(salePoint, 'name3', previousSalePoint),
            name: 'Επωνυμία 2',
            value: this.commonService.setValue(salePoint.name3)
          },
          {
            color: this.setFieldColor(salePoint, 'supplier_name', previousSalePoint),
            name: 'Προμηθευτής',
            value: this.commonService.setValue(salePoint.supplier_name)
          },
          {
            color: this.setFieldColor(salePoint, 'taxcode', previousSalePoint),
            name: 'Κωδικός Εφορίας',
            value: this.commonService.setValue(salePoint.taxcode)
          },
          {
            color: this.setFieldColor(salePoint, 'key1', previousSalePoint),
            name: 'Key1',
            value: this.commonService.setValue(salePoint.key1)
          },
          {
            color: this.setFieldColor(salePoint, 'has_cases_name', previousSalePoint),
            name: 'Θήκες',
            value: this.commonService.setValue(salePoint.has_cases_name)
          },
          {
            phantom: true
          }
        ]
      },
      {
        title: 'Στοιχεία Επικοινωνίας',
        values: [
          {
            color: this.setFieldColor(salePoint, 'address', previousSalePoint),
            name: 'Διεύθυνση',
            value: this.commonService.setValue(salePoint.address)
          },
          {
            color: this.setFieldColor(salePoint, 'address2', previousSalePoint),
            name: 'Διεύθυνση 2',
            value: this.commonService.setValue(salePoint.address2)
          },
          {
            color: this.setFieldColor(salePoint, 'postal_code', previousSalePoint),
            name: 'Τ.Κ.',
            value: this.commonService.setValue(salePoint.postal_code)
          },
          {
            color: this.setFieldColor(salePoint, 'city', previousSalePoint),
            name: 'Πόλη',
            value: this.commonService.setValue(salePoint.city)
          },
          {
            color: this.setFieldColor(salePoint, 'country_name', previousSalePoint),
            name: 'Χώρα',
            value: this.commonService.setValue(salePoint.country_name)
          },
          {
            color: this.setFieldColor(salePoint, 'region_description', previousSalePoint),
            name: 'Νομός',
            value: this.commonService.setValue(salePoint.region_description)
          },
          {
            color: this.setFieldColor(salePoint, 'postal_area_description', previousSalePoint),
            name: 'Περιοχή',
            value: this.commonService.setValue(salePoint.postal_area_description)
          },
          {
            color: this.setFieldColor(salePoint, 'phone_number1', previousSalePoint),
            name: 'Τηλέφωνο 1',
            value: this.commonService.setValue(salePoint.phone_number1)
          },
          {
            color: this.setFieldColor(salePoint, 'phone_number2', previousSalePoint),
            name: 'Τηλέφωνο 2',
            value: this.commonService.setValue(salePoint.phone_number2)
          },
          {
            color: this.setFieldColor(salePoint, 'mobile', previousSalePoint),
            name: 'Κινητό',
            value: this.commonService.setValue(salePoint.mobile)
          },
          {
            color: this.setFieldColor(salePoint, 'fax', previousSalePoint),
            name: 'Fax',
            value: this.commonService.setValue(salePoint.fax)
          },
          {
            color: this.setFieldColor(salePoint, 'email', previousSalePoint),
            name: 'Email',
            value: this.commonService.setValue(salePoint.email)
          },
          {
            phantom: true
          },
          {
            phantom: true
          }
        ]
      },
      {
        title: 'Επιπλέον Πληροφορίες',
        values: [
          {
            color: this.setFieldColor(salePoint, 'extra_sales_group_description', previousSalePoint),
            name: 'Χειμερινό - Έκτακτο Δρομολόγιο',
            value: this.commonService.setValue(salePoint.extra_sales_group_description)
          },
          {
            color: this.setFieldColor(salePoint, 'has_krikri_refrigerator_name', previousSalePoint),
            name: 'Ψυγείο ΚΡΙΚΡΙ',
            value: this.commonService.setValue(salePoint.has_krikri_refrigerator_name)
          },
          {
            color: this.setFieldColor(salePoint, 'payment_method_name', previousSalePoint),
            name: 'Τρόπος Πληρωμής',
            value: this.commonService.setValue(salePoint.payment_method_name)
          },
          {
            color: this.setFieldColor(salePoint, 'pricing_method_name', previousSalePoint),
            name: 'Τρόπος Τιμολόγησης',
            value: this.commonService.setValue(salePoint.pricing_method_name)
          },
          {
            color: this.setFieldColor(salePoint, 'is_franchise_name', previousSalePoint),
            name: 'Είναι Franchise',
            value: this.commonService.setValue(salePoint.is_franchise_name)
          },
          {
            color: this.setFieldColor(salePoint, 'chain_partner', previousSalePoint),
            name: 'Συνεργάτης Αλυσίδας',
            value: this.commonService.setValue(salePoint.chain_partner)
          },
          {
            color: this.setFieldColor(salePoint, 'chain_partner_vat_number', previousSalePoint),
            name: 'Α.Φ.Μ. Συνεργάτη Αλυσίδας',
            value: this.commonService.setValue(salePoint.chain_partner_vat_number)
          },
          {
            color: this.setFieldColor(salePoint, 'chain_partner_address', previousSalePoint),
            name: 'Διεύθυνση Συνεργάτη Αλυσίδας',
            value: this.commonService.setValue(salePoint.chain_partner_address)
          },
          {
            color: this.setFieldColor(salePoint, 'gln', previousSalePoint),
            name: 'GLN',
            value: this.commonService.setValue(salePoint.gln)
          },
          {
            color: this.setFieldColor(salePoint, 'customer_store_code', previousSalePoint),
            name: 'Κωδικός Καταστήματος Πελάτη',
            value: this.commonService.setValue(salePoint.customer_store_code)
          },
          {
            color: this.setFieldColor(salePoint, 'credit_limit', previousSalePoint),
            name: 'Πιστωτικό Όριο',
            value: this.commonService.setValue(salePoint.credit_limit)
          },
          {
            color: this.setFieldColor(salePoint, 'notes', previousSalePoint),
            name: 'Παρατηρήσεις',
            value: this.commonService.setValue(salePoint.notes)
          },
          {
            phantom: true
          },
          {
            phantom: true
          }
        ]
      }
    ];
  }

  private setFieldColor(currentSalePoint: any, field?: string, previousSalePoint?: any): string {
    return previousSalePoint && currentSalePoint[field] !== previousSalePoint[field] ? '#dd0330' : '';
  }
}
